import { useState } from 'react';

import { ProjectAbbreviatedFields } from '@playbooks/components/project/project-abbreviated-fields';
import { Button } from '@playbooks/ui/components/button';
import { DialogFooter, DialogHeader, DialogTitle } from '@playbooks/ui/components/dialog';
import { FormFileInput } from '@playbooks/ui/components/form-controls';

import { useAction } from 'hooks';

const LaunchFlowUpload = ({ model, contexts, onClose, onNext }) => {
	const [project, setProject] = useState<any>({});
	const [file, setFile] = useState<File | null>(null);
	const { workspace, store } = contexts;

	// Actions
	const [onSave, saveTask] = useAction(async () => {
		const data = new FormData();
		Object.entries(project).forEach(
			([key, value]) => value !== undefined && value !== null && data.append(key, String(value)),
		);
		if (file) data.append('project', file);
		const response = await store.saveRecord({
			url: `${workspace.rootApi}/projects`,
			data,
		});
		onNext(response.data);
	});

	// Methods
	const onSubmit = e => {
		e.preventDefault();
		if (!file) return;
		onSave();
	};

	// Render
	return (
		<form onSubmit={onSubmit}>
			<DialogHeader>
				<DialogTitle>File Upload</DialogTitle>
			</DialogHeader>
			<div>
				<ProjectAbbreviatedFields project={project} setProject={setProject} />
				<FormFileInput
					type='file'
					accept='.zip,application/zip'
					required
					onChange={event => setFile(event.target.files?.[0] || null)}
				/>
			</div>
			<DialogFooter>
				<Button variant='secondary' onClick={onClose}>
					Cancel
				</Button>
				<Button type='submit' disabled={!file} isLoading={saveTask.running}>
					Save
				</Button>
			</DialogFooter>
		</form>
	);
};

export { LaunchFlowUpload };
